export const EVENT_MOMENT_KINDS = ['click', 'change', 'submit'] as const;

export type EventMomentKind = (typeof EVENT_MOMENT_KINDS)[number];

const CLICK_INFERRED_EVENT_NAMES = new Set([
  'ElementClicked',
  'ProductClicked',
]);

export type EventKindSource = {
  kind?: string;
  eventName?: string;
};

export type ResolvedEventKind =
  | { ok: true; kind: EventMomentKind }
  | { ok: false; message: string };

function isEventMomentKind(value: string): value is EventMomentKind {
  return (EVENT_MOMENT_KINDS as readonly string[]).includes(value);
}

export function resolveEventKind(entry: EventKindSource): ResolvedEventKind {
  if (entry.kind !== undefined) {
    if (isEventMomentKind(entry.kind)) {
      return { ok: true, kind: entry.kind };
    }
    return {
      ok: false,
      message: 'kind must be click, change, or submit',
    };
  }

  if (
    entry.eventName !== undefined &&
    CLICK_INFERRED_EVENT_NAMES.has(entry.eventName.trim())
  ) {
    return { ok: true, kind: 'click' };
  }

  return {
    ok: false,
    message:
      'needs a kind of click, change, or submit. ElementClicked and ProductClicked are read as click when kind is omitted',
  };
}
